import { render, staticRenderFns } from "./CategorySetting.vue?vue&type=template&id=af3d82c0&scoped=true&"
import script from "./CategorySetting.vue?vue&type=script&lang=js&"
export * from "./CategorySetting.vue?vue&type=script&lang=js&"
import style0 from "./CategorySetting.vue?vue&type=style&index=0&id=af3d82c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3d82c0",
  null
  
)

export default component.exports